/* RESPONSIBLE TEAM: team-phone */
/* eslint-disable @intercom/intercom/no-bare-strings */

export type FinVoiceVoiceModelOptions = {
  value: FinVoiceVoiceModel;
  text: string;
};

export type FinVoiceVoiceModel =
  | 'eleven_turbo_v2'
  | 'eleven_flash_v2_5'
  | 'eleven_multilingual_v2'
  | 'sonic-2';

export const FIN_VOICE_VOICE_MODEL_OPTIONS: FinVoiceVoiceModelOptions[] = [
  { value: 'eleven_turbo_v2', text: 'Turbo' },
  { value: 'eleven_flash_v2_5', text: 'Flash' },
  { value: 'eleven_multilingual_v2', text: 'Multilingual' },
  { value: 'sonic-2', text: 'Sonic' },
];
